import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { useSelector } from "react-redux";
import AddEarningModal from "../../../components/comman/AddEarningModal";
import AddDeductionModal from "../../../components/comman/AddDeductionModal";
import EditIcon from "../../../components/Icons/EditIcon";
import DeleteUnfilledIcon from "../../../components/Icons/DeleteUnFilledIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";

export default function AddSiteSalaryHead() {
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = useSelector((state) => state.root.userDetails);
  const [selectedId, setSelectedId] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedSalaryHeads, setSelectedSalaryHeads] = useState({
    earning: [],
    deduction: [],
  });
  const SiteSalaryHeadData = location?.state?.SiteSalaryHeadData || [];
  const existingSiteIds = SiteSalaryHeadData?.map((item) => item.id);
  const [modalData, setModalData] = useState({});
  // console.log("modaldata-------------", modalData);
  // console.log("selectedSalaryHeads-------------", selectedSalaryHeads);
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  const [earningModal, setEarningModal] = useState(false);
  const toggleEarningModal = () => {
    setEarningModal(!earningModal);
  };
  const [deductionModal, setDeductionModal] = useState(false);
  const toggleDeductionModal = () => {
    setDeductionModal(!deductionModal);
  };
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const [pageStates, setPageStates] = useState({
    siteList: [],
    earnings: [],
    deductions: [],
    siteSalaryHeadDetail: [],
    isLoading: false,
  });
  // console.log("pageStates===>",pageStates);

  useEffect(() => {
    GetSiteList();
    GetSalaryHead("earning");
    GetSalaryHead("deduction");
    if (location?.state?.data) {
      GetSiteSalaryHeadDetail();

      setTimeout(() => {
        reset({
          siteId: location?.state?.data?.id,
        });
      }, 700);
    }
  }, []);

  const selectedSiteId = watch("siteId");

  const GetSiteList = (companyId = null) => {
    let options = {
      method: "GET",
    };
    let API =
      userDetails?.type === 2
        ? apiUrl.get_site +
        `?type=site&pageSize=${100}${companyId ? `&companyId=${companyId}` : ""
        }`
        : apiUrl.get_user_site + `?pageSize=${100}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          siteList: response?.data?.site,
        }));
      }
    });
  };

  const GetSalaryHead = (type) => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_salary_head + `pageSize=50&type=${type}`;
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          ...(type === "earning" && { earnings: res?.data?.salaryHead }),
          ...(type === "deduction" && { deductions: res?.data?.salaryHead }),
        }));
      }
    });
  };

  const GetSiteSalaryHeadDetail = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_site_salary_head_detail +
      `?siteId=${location?.state?.data?.id}`;
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        const earning = [];
        const deduction = [];
        for (const item of res.data) {
          // console.log(item, '===========')
          if (item?.salaryhead?.type == "earning") {
            earning.push(item);
          } else {
            deduction.push(item);
          }
        }

        setSelectedSalaryHeads((prev) => ({
          ...prev,
          earning: earning,
          deduction: deduction,
        }));
      }
    });
  };

  const handleUpdateSalaryHead = (data, type) => {
    if (type === "earning") {
      setModalData(data);
      toggleEarningModal();
    }
    if (type === "deduction") {
      setModalData(data);
      toggleDeductionModal();
    }
  };

  const handleRemoveSalaryHead = () => {
    const API = `${apiUrl?.delete_site_salary_head}?siteSalaryHeadId=${selectedId}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        toast.success(response.message);
        setSelectedSalaryHeads((prev) => ({
          // console.log(prev, selectedType, prev[selectedType], selectedId)
          ...prev,
          [selectedType]: prev[selectedType]?.filter(
            (item) => item.id != selectedId
          ),
        }));
        toggleModal();
      } else {
        toast.error(response.message);
      }
    });
  };

  const ActionHandler = (data, type) => {
    setSelectedType(type);
    setSelectedId(data);
    toggleModal();
  };

  const onSubmit = (data) => {
    if (selectedSalaryHeads?.length === 0) {
      toast.info("Please select Earning or Deduction before submit");
      return;
    }
    const submitData = {
      siteId: data?.siteId,
      // salaryHeadId: selectedSalaryHeads.map((item) => item.id),
    };
    // console.log("submitData >>>>>>>>>>>>", submitData);

    const options = {
      method: "POST",
      data: submitData,
    };
    let API = location?.state?.data
      ? apiUrl?.update_site_salary_head + `?siteId=${location?.state?.data?.id}`
      : apiUrl?.create_site_salary_head;
    setPageStates((prev) => ({
      ...prev,
      isLoading: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        isLoading: false,
      }));
      if (response?.status === true) {
        toast.success(response?.message);
        navigate(-1);
      } else {
        toast.error(response?.message);
      }
    });
  };

  // console.log("selectedSalaryHead=====>", selectedSalaryHeads);
  // console.log("selectedId=====>", selectedId);

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Add "} Site Salary Head
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-BasicDetails"
                  role="tabpanel"
                  aria-labelledby="pills-BasicDetails-tab"
                  tabIndex={0}
                >
                  <div className="d-flex justify-content-between">
                    <div className="col-12 col-md-6 col-lg-3">
                      <div className="form-group mb-3">
                        <label className="form-label">Site</label>
                        {/* {console.log("purchaseReqData", purchaseReqData?.site)} */}

                        <select
                          className={`form-select form-control ${errors.siteId ? "is-invalid" : ""
                            }`}
                          disabled={location?.state?.data}
                          aria-label="Default select example"
                          {...register("siteId", {
                            required: "This field is Required",
                          })}
                        >
                          <option value="">Select Site</option>
                          {pageStates?.siteList?.length > 0 ? (
                            pageStates?.siteList?.map((item, index) => (
                              <option
                                key={index}
                                value={item?.siteId || item?.id}
                                disabled={existingSiteIds?.includes(item?.siteId || item?.id)}
                              >
                                {item?.site?.name || item?.name}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>
                              No data found
                            </option>
                          )}
                        </select>

                        <ErrorMessage message={errors?.siteId?.message} />
                      </div>
                    </div>

                    <div className="d-flex gap-4 py-5">
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        onClick={() => {
                          if (!selectedSiteId) {
                            toast.info("Please select Site before add earning");
                          } else {
                            setModalData({});
                            toggleEarningModal();
                          }
                        }}
                      >
                        Add Earning
                      </button>
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        onClick={() => {
                          if (!selectedSiteId) {
                            toast.info(
                              "Please select Site before add deduction"
                            );
                          } else {
                            setModalData({});
                            toggleDeductionModal();
                          }
                        }}
                      >
                        Add Deduction
                      </button>
                    </div>
                  </div>

                  <div className="row my-5">
                    <div className="col-12 col-md-6 mb-4">
                      <div className="border rounded p-3 h-100 bg-success-subtle">
                        <h4 className="text-center mb-3">Earnings</h4>

                        <div className="d-flex flex-column gap-2">
                          {selectedSalaryHeads?.earning?.length <= 0 ? (
                            <div className="text-muted text-center fst-italic">
                              No earnings selected
                            </div>
                          ) : (
                            selectedSalaryHeads?.earning?.map((item) => (
                              <div
                                className="border rounded px-3 py-1 d-flex justify-content-between align-items-center bg-light mx-2"
                                key={item?.id}
                              >
                                <span className="fs-4">{item?.salaryhead?.name}</span>
                                <div className="d-flex gap-2">
                                  {!item?.salaryhead?.isBase && (
                                    <>
                                      <button
                                        type="button"
                                        className="bg-transparent text-black"
                                        onClick={() =>
                                          handleUpdateSalaryHead(
                                            item,
                                            "earning"
                                          )
                                        }
                                      >
                                        <EditIcon />
                                      </button>
                                      <button
                                        type="button"
                                        className="bg-transparent text-black"
                                        onClick={() =>
                                          ActionHandler(
                                            item?.id,
                                            item?.salaryhead?.type
                                          )
                                        }
                                      >
                                        <DeleteUnfilledIcon />
                                      </button>{" "}
                                    </>
                                  )}
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 mb-4">
                      <div className="border rounded p-3 h-100 bg-danger-subtle">
                        <h4 className="text-center mb-3">Deductions</h4>

                        <div className="d-flex flex-column gap-2">
                          {selectedSalaryHeads?.deduction?.length <= 0 ? (
                            <div className="text-muted text-center fst-italic">
                              No deductions selected
                            </div>
                          ) : (
                            selectedSalaryHeads?.deduction?.map((item) => (
                              <div
                                className="border rounded px-3 py-1 d-flex justify-content-between align-items-center bg-light mx-2"
                                key={item?.id}
                              >
                                <span className="fs-4">{item?.salaryhead?.name}</span>
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    className="bg-transparent text-black"
                                    onClick={() =>
                                      handleUpdateSalaryHead(item, "deduction")
                                    }
                                  >
                                    <EditIcon />
                                  </button>
                                  <button
                                    type="button"
                                    className="bg-transparent text-black"
                                    onClick={() =>
                                      ActionHandler(
                                        item?.id,
                                        item?.salaryhead?.type
                                      )
                                    }
                                  >
                                    <DeleteUnfilledIcon />
                                  </button>
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {!location?.state?.data && (
                    <div className="d-flex align-items-center justify-content-end gap-4">
                      <button
                        className="btn btn-secondary px-5"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                      <button
                        disabled={pageStates?.isLoading}
                        type="submit"
                        className="btn btn-primary px-5"
                      >
                        {pageStates?.isLoading ? (
                          <Spinner />
                        ) : location?.state?.data ? (
                          "Update"
                        ) : (
                          "Create"
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <AddEarningModal
        modal={earningModal}
        toggle={toggleEarningModal}
        earningsList={pageStates?.earnings}
        selectedSalaryHeads={selectedSalaryHeads}
        selectedSiteId={selectedSiteId}
        GetSiteSalaryHeadDetail={GetSiteSalaryHeadDetail}
        GetSalaryHead={GetSalaryHead}
        modalData={modalData}
        setModalData={setModalData}
      />
      <AddDeductionModal
        modal={deductionModal}
        toggle={toggleDeductionModal}
        deductionsList={pageStates?.deductions}
        selectedSalaryHeads={selectedSalaryHeads}
        selectedSiteId={selectedSiteId}
        GetSiteSalaryHeadDetail={GetSiteSalaryHeadDetail}
        GetSalaryHead={GetSalaryHead}
        modalData={modalData}
        setModalData={setModalData}
      />
      <ConfirmModal
        modal={modal}
        toggle={() => toggleModal()}
        submitHandler={handleRemoveSalaryHead}
      />
    </>
  );
}
